<script setup lang="ts">
  import { ref } from 'vue'
  import { useApi } from '@/functions/api'
  import { useExportFileStore } from '@/stores/export-file'
  import { useToastStore } from '@/stores/toast'

  const props = defineProps<{
    endpoint: string,
    params?: object,
    disabled?: boolean,
  }>()

  const api = useApi()
  const exportFileStore = useExportFileStore()
  const toastStore = useToastStore()

  const submitting = ref(false)
  const requestExcel = async () => {
    submitting.value = true
    try {
      const exportFile = await api.GET<ExportFile>(props.endpoint, { ...props.params ?? {}, output: 'excel' })
      exportFileStore.addDownloading(exportFile)
      toastStore.add('File akan otomatis terunduh ketika sudah siap.')
    } finally {
      submitting.value = false
    }
  }
</script>

<template>
  <app-button
    class="btn-info"
    :loading="submitting"
    :disabled="disabled"
    @click="requestExcel()">
    Export
  </app-button>
</template>
